import 'vuetify/styles'
import { createVuetify } from 'vuetify'

import { StringDateAdapter } from 'vuetify/date/adapters/string'

export default createVuetify({
  theme: {
    defaultTheme: 'dark'
  },
  date: {
    // https://vuetifyjs.com/en/features/dates/#string-adapter
    // "Date objects can be inconvenient to work with, especially if you’re just passing the value straight to a fetch request.
    // Vuetify also exports a StringDateAdapter that will cause date components to emit strings instead."
    // Using the adapter here so that v-date-picker works as it did in Vuetify 2
    adapter: StringDateAdapter
  }
})
